<template>
  <div>
    <div class="application-box application-employee">
      <div class="application-box__title application-box__title_flex">
        {{ $t("request.responsible") }}
        <svg
          style="cursor:pointer"
          v-if="$guard('write', 'Orders')"
          @click="showResponsible"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8" cy="8" r="7.5" stroke="var(--menu-text-color)" />
          <path
            d="M8.00012 4.66669V11.3334"
            stroke="var(--menu-text-color)"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.3332 8H4.6665"
            stroke="var(--menu-text-color)"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
    <!-- <template v-if="!isSingle"> -->
    <div class="application-employee__block mt16" v-bar>
      <div class="application-employee__list">
        <div class="application-employee__item" v-for="user in responsible" :key="user.id">
          <div class="application-employee__item-remove" @click="removeResponsible(user.id)">
            <img src="/images/icon/remove.svg" alt />
          </div>
          <div
            class="application-employee__item-img"
            :style="{ backgroundImage: 'url(' +getImage(user)+ ')' }"
          ></div>
          <div
            class="application-employee__item-name"
            :title="user.first_name + ' ' + user.last_name"
          >
            {{ user.first_name }}
            {{ user.last_name }}
          </div>
        </div>
      </div>
    </div>
    <!-- </template> -->
    <!-- <template v-else>
      <div class="application-employee__block mt16" v-bar>
        <div class="application-employee__list">
          <div class="application-employee__item" v-for="user in responsible" :key="user.id">
            <div class="application-employee__item-remove" @click="removeResponsible(user.id)">
              <img src="/images/icon/remove.svg" alt />
            </div>
            <div
              class="application-employee__item-img"
              :style="{ backgroundImage: 'url(' + user.image + ')' }"
            ></div>
            <div
              class="application-employee__item-name"
              :title="user.first_name + ' ' + user.last_name"
            >
              {{ user.first_name }}
              {{ user.last_name }}
              ( {{ user.time }} )
            </div>
          </div>
        </div>
      </div>
    </template>-->

    <template v-if="!isSingle">
      <modal :show="showModalAddresponsible" :dark="true" @close="closeModal">
        <add-responsible-for-pdf
          :responsibleData="responsible"
          :hide="false"
          :tags="tags"
          @close="closeModal"
          @confirm="confirmResponsibleMultiple"
        ></add-responsible-for-pdf>
      </modal>
    </template>
    <template v-else>
      <modal :show="showModalAddresponsible" :dark="true" @close="closeModal">
        <add-responsible
          :responsibleData="responsible"
          :tags="tags"
          @close="closeModal"
          @confirm="confirmResponsible"
          :serviceId="service_id"
          :hide="false"
          :service_id="service_id"
          :office_id="office_id"
          :address="address"
          :duration="duration"
          :date="date"
        />
      </modal>
    </template>
  </div>
</template>

<script>
export default {
    name: 'orders-executors',
    props: {
        isSingle: {
            required: true,
        },
        tags: {
            required: true,
        },
        duration: {
            required: true,
        },
        date: {
            required: true,
        },
        address: {
            required: true,
        },
        office_id: {
            required: true,
        },
        service_id: {
            required: true,
        },
        responsible: {
            required: true,
        },
    },
    data() {
        return {
            showModalAddresponsible: false,
        }
    },
    watch: {
        isSingle(v) {
            if (v) {
                this.responsible = []
            }
        },
    },
    methods: {
        getImage(user) {
            return user.small_image ? user.small_image : user.image
        },
        removeResponsible(id) {
            const index = this.responsible.findIndex((item) => item.id === id)
            this.responsible.splice(index, 1)
            this.$emit('onRemoveResponsible')
        },
        showResponsible() {
            this.showModalAddresponsible = true
        },
        closeModal() {
            this.showModalAddresponsible = false
        },
        confirmResponsibleMultiple() {
            this.$emit('onConfirmResponsible', {
                data: this.responsible,
            })
        },
        confirmResponsible({
            data, hours, minutes, hasChanged = false,
        }) {
            this.responsible = data
            this.$emit('onConfirmResponsible', {
                hours, minutes, data, hasChanged,
            })
        },
    },
}
</script>
